import React, { useState } from 'react';
import {
    Box, FormControl, FormLabel, Input, Button, useToast, Stack, Flex
} from '@chakra-ui/react';

const ChangePasswordComponent = ({ onSuccess, onCancel }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const toast = useToast();

    const handleChangePassword = async () => {
        if (newPassword !== confirmPassword) {
            toast({
                title: 'Passwords do not match',
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
            return;
        }

        if (newPassword.length < 6) {
            toast({
                title: 'Password too short',
                description: 'Password must be at least 6 characters long.',
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
            return;
        }

        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    currentPassword,
                    newPassword
                })
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message || 'Password change failed');

            toast({
                title: 'Password changed successfully',
                status: 'success',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });

            onSuccess();

            // Reset fields
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (error) {
            toast({
                title: 'Error',
                description: error.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
        }
    };

    return (
        <Box border="1px solid #ddd" p={4} borderRadius="md">
            <Stack spacing={3}>
                <Input
                    placeholder="Current Password"
                    type="password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <Input
                    placeholder="New Password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <Input
                    placeholder="Confirm New Password"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <Flex gap={3}>
                    <Button variant="solid-green-btn" fontWeight={600} flex={1} onClick={handleChangePassword}>Save</Button>
                    <Button variant="solid-grey-btn" fontWeight={600} flex={1} onClick={onCancel}>Cancel</Button>
                </Flex>
            </Stack>
        </Box>
    );
};

export default ChangePasswordComponent;